import { getIndexedParameteredProducts } from '@scandipwa/scandipwa/src/util/Product';
import {
    PRODUCTS_IN_WISHLIST as SOURCE_PRODUCTS_IN_WISHLIST,
    getInitialState as sourceGetInitialState,
    deleteProperty as sourceDeleteProperty,
    removeItemFromWishlist as sourceRemoveItemFromWishlist,
    clearWishlist as sourceClearWishlist,
    updateAllProductsInWishlist as sourceUpdateAllProductsInWishlist,
    WishlistReducer as SourceWishlistReducer,
} from 'SourceStore/Wishlist/Wishlist.reducer';

//TODO: implement PRODUCTS_IN_WISHLIST
export const PRODUCTS_IN_WISHLIST = SOURCE_PRODUCTS_IN_WISHLIST;

//TODO: implement getInitialState
export const getInitialState = sourceGetInitialState;

//TODO: implement deleteProperty
export const deleteProperty = sourceDeleteProperty;

//TODO: implement removeItemFromWishlist
export const removeItemFromWishlist = sourceRemoveItemFromWishlist;

//TODO: implement clearWishlist
export const clearWishlist = sourceClearWishlist;

//TODO: implement updateAllProductsInWishlist
export const updateAllProductsInWishlist = (action) => {
    const { products: initialProducts } = action;

    const products = getIndexedParameteredProducts(initialProducts);

    // BrowserDatabase.setItem(
    //     products,
    //     PRODUCTS_IN_WISHLIST,
    // );

    return { productsInWishlist: products, isLoading: false };
};

//TODO: implement WishlistReducer
export const WishlistReducer = SourceWishlistReducer;

export default WishlistReducer;
